import styled from "styled-components";
import { theme } from "styles/theme";

export const SchedulesContainer = styled.div`
  background-color: transparent;
  border: none;
  border-radius: 0;
  overflow: visible;
  box-shadow: none;
  height: fit-content;
  margin-top: 1.5rem;
`;

export const SchedulesTitle = styled.h3`
  padding: 0 0 0.625rem;
  margin: 0 0 0.75rem;
  background-color: transparent;
  color: ${theme.colors.textPrimary};
  border-bottom: 1px solid ${theme.colors.border};
  font-weight: ${theme.fontWeights.medium};
  font-size: 0.95rem;
`;

export const SchedulesList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  padding: 0;
`;

export const ScheduleEditIcon = styled.div`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background-color: ${theme.colors.bgLighter};
  color: ${theme.colors.textSecondary};
  border: 1px solid ${theme.colors.border};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.15s ease;

  &:hover {
    color: ${theme.colors.textPrimary};
    border-color: ${theme.colors.textSecondary};
  }
`;

export const ScheduleItem = styled.div`
  background-color: ${theme.colors.bgLight};
  border-radius: ${theme.borderRadius.small};
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  width: 100%;
  border: none;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${theme.colors.lightGrey};

    ${ScheduleEditIcon} {
      opacity: 1;
    }
  }
`;

export const ScheduleLabel = styled.div`
  font-size: 0.75rem;
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.textSecondary};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.35rem;
`;

export const ScheduleTime = styled.div`
  font-weight: ${theme.fontWeights.medium};
  margin-bottom: 0.25rem;
  font-size: 0.95rem;
  color: ${theme.colors.textPrimary};
`;

export const ScheduleSpeed = styled.div`
  font-size: 0.8rem;
  color: ${theme.colors.textSecondary};
  font-weight: ${theme.fontWeights.medium};
`;
